export default __webpack_public_path__ + "static/media/img-cyln-premium-face.dacc9b6f.png";